if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);

            // 🚀 Inicializar checkbox de regalo dentro del modal
            this.initQuickAddGift();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attr) => newScriptTag.setAttribute(attr.name, attr.value));
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

initQuickAddGift() {
  const modalContent = this.modalContent;
  if (!modalContent) return;

  const giftCheckbox = modalContent.querySelector('#gift-checkbox');
  if (!giftCheckbox || giftCheckbox.dataset.giftInit) return;
  giftCheckbox.dataset.giftInit = 'true';

  giftCheckbox.addEventListener('change', () => {
    console.log('[GiftDebug][QuickAdd] Checkbox cambiado:', giftCheckbox.checked, '→ Variant ID:', giftCheckbox.value);
  });

  const addButton = modalContent.querySelector('form[action*="/cart/add"] button[type="submit"]');
  if (!addButton) return;

  addButton.addEventListener('click', async () => {
    const giftId = giftCheckbox?.checked ? Number(giftCheckbox.value) : null;
    if (!giftId) return;

    // 🔥 Obtengo el estado inicial del carrito
    const initialCart = await fetch('/cart.js').then(r => r.json());
    const initialCount = initialCart.items.length;
    console.log('[GiftDebug][QuickAdd] Carrito inicial con', initialCount, 'items. Esperando producto principal...');

    const checkCart = async (tries = 0) => {
      try {
        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();

        if (cart.items.length > initialCount) {
          console.log('[GiftDebug][QuickAdd] Producto principal detectado, agregando regalo', giftId);

          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: giftId, quantity: 1, properties: { _Regalo: 'Sí' } }]
            })
          });

          if (!resp.ok) {
            console.error('[GiftDebug][QuickAdd] Error al agregar regalo:', await resp.text());
            return;
          }

          const updatedCart = await resp.json();
          console.log('[GiftDebug][QuickAdd] Regalo agregado al carrito:', updatedCart);

          // refrescar drawer si existe
          const drawer = document.querySelector('#CartDrawer');
          if (drawer) {
            fetch('/cart?section_id=cart-drawer')
              .then(r => r.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newDrawer = doc.querySelector('#CartDrawer');
                if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
                console.log('[GiftDebug][QuickAdd] Drawer refrescado 🛍️');
              });
          }

          giftCheckbox.checked = false;
          return;
        }

        // Reintento
        if (tries < 10) {
          setTimeout(() => checkCart(tries + 1), 300);
        } else {
          console.warn('[GiftDebug][QuickAdd] No detecté producto principal después de 10 intentos');
        }
      } catch (err) {
        console.error('[GiftDebug][QuickAdd] Error chequeando carrito:', err);
      }
    };

    checkCart();
  });
}



      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((el) => {
          el.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
